export function groupBy<T, K extends keyof T>(list: T[], key: K): Map<T[K], T[]> {
  const map = new Map<T[K], T[]>();
  for (const item of list) {
    const groupKey = item[key];
    if (!map.has(groupKey)) {
      map.set(groupKey, []);
    }
    map.get(groupKey)?.push(item);
  }
  return map;
}

export function groupByAsList<T, K extends keyof T>(
  list: T[],
  key: K
): {
  key: T[K];
  items: T[];
}[] {
  const map = new Map<T[K], T[]>();
  for (const item of list) {
    const groupKey = item[key];
    if (!map.has(groupKey)) {
      map.set(groupKey, []);
    }
    map.get(groupKey)?.push(item);
  }

  const result: { key: T[K]; items: T[] }[] = [];
  for (const [key, items] of map.entries()) {
    result.push({ key, items });
  }

  return result;
}
